import { Dialog, DialogContent } from '@/components/ui/dialog';
import Image from 'next/image';

export const ProductFullDetailMask = ({ open, onOpenChange }) => {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent
        className='border-none bg-transparent shadow-none sm_max-w-[425px]'
        showCloseButton={false}
        onInteractOutside={e => {
          e.preventDefault();
        }}
      >
        <div className='flex h-full w-full flex-col items-center justify-center gap-[18px] text-center'>
          <Image
            src={`${process.env.NEXT_PUBLIC_BASE_PATH}/product-full-detail/product-full-detail-mask-48.webp?v=1.2.3`}
            alt='Product Full Detail Mask'
            width={60}
            height={60}
            className='text-center'
          />
          <p className='max-w-[338px] text-center text-white'>
            Your review will appear here within 48 hours! Thanks for your time!
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
